import { render, staticRenderFns } from "./ThgHome.vue?vue&type=template&id=72f2769a"
import script from "./ThgHome.vue?vue&type=script&lang=ts"
export * from "./ThgHome.vue?vue&type=script&lang=ts"
import style0 from "./ThgHome.vue?vue&type=style&index=0&id=72f2769a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports